export default __webpack_public_path__ + "static/media/JayVerma.9788fc98.jpeg";